<template lang="pug">
    v-dialog( fullscreen max-width="80%" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Detalle de solicitud de ausencia
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    v-toolbar( color="primary" dark flat )
                        v-toolbar-title Información
                        v-spacer
                        v-toolbar-items
                            v-btn.mt-2.mr-4(
                                color="green darken-3"
                                depressed
                                @click="submitAuthorized"
                                v-if="isAbsenceRequestAuthorized && $can('AUTHORIZE_CONFIRM_ABSENCE_REQUEST')"
                                )
                                v-icon done_all 
                                span.ml-2 autorizar
                            v-btn.mt-2(
                                color="red darken-3"
                                depressed
                                @click="submitRejected"
                                v-if="isAbsenceRequestAuthorized && $can('AUTHORIZE_CONFIRM_ABSENCE_REQUEST')"
                                )
                                v-icon assignment_late 
                                span.ml-2 rechazar
                    crud-form(
                        :fields="fields"
                        ref="refAbsenceRequestFormDialog"
                        :readOnly="!$can('EDIT_ABSENCE_REQUEST')"
                        :editable="isEditable"
                        @editable="submitEditableCF($event)"
                        :noButtons="!isEditable"
                        submitText="Guardar"
                        @submitForm="submitFormUpdate($event)"
                        )
</template>

<script>
//-
import { CrudForm } from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import FieldsDialogAbsenceRequest from './FieldsDialogAbsenceRequest'
import {
    authorizeAbsenceRequest,
    rejectAbsenceRequest,
    updateAbsenceRequest,
    fetchAll,
} from '@/services/api/absenceRequest'
import EmployeeService from '@/services/api/employee'
import moment from 'moment'
//-
export default {
    name: 'dialog-absence-request',
    props: {
        absenceRequestObj: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            fields: FieldsDialogAbsenceRequest,
            open: false,
            isAbsenceRequestAuthorized: false,
            editableValue: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        isEditable: {
            get: function() {
                return this.editableValue && this.$can('EDIT_ABSENCE_REQUEST')
            },
            set: function(val) {
                this.editableValue = val
            },
        },
    },
    methods: {
        // -- UI Modification
        sendMessageSnackbar: function(action, message) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(action)
            let payload = this.fillSnack('warning', message, '')
            this.initSnackbar(payload)
        },
        submitAuthorized: function() {
            this.sendMessageSnackbar(
                'Autorizar',
                '¿Desea autorizar/aprobar la solicitud de ausencia?'
            )
        },
        submitRejected: function() {
            this.sendMessageSnackbar(
                'Rechazar',
                '¿Desea rechazar la solicitud de ausencia?'
            )
        },
        submitFormUpdate: async function(event) {
            let response = await updateAbsenceRequest(
                this.absenceRequestObj.id,
                event
            )
            if (response.status == 'success') {
                this.showSnackbar(
                    'success',
                    'Solicitud de ausencia modificada exitosamente',
                    ''
                )
                this.$emit('success')
                this.toggleOpen()
            } else {
                let payload = this.fillSnack('error', 'Error', response.error)
                this.initSnackbar(payload)
            }
        },
        submitEditableCF: function(e) {
            switch (e.editable) {
                case true:
                    this.isAbsenceRequestAuthorized = false
                    break
                case false:
                    this.isAbsenceRequestAuthorized = true
                    break
            }
        },
        // -- Data fetching
        getInfoAbsenceRequest: function(data) {
            this.fields[0].value = data.hr_employee_id
            this.fields[1].value = data.hr_absence_request_type_id
            this.fields[2].value = moment(data.init_date).format('YYYY-MM-DD')
            this.fields[3].value = moment(data.end_date).format('YYYY-MM-DD')
            this.fields[4].value = data.description
            this.fields[5].value = data.comment
            this.fields = [...this.fields]
        },
        // -- Data handling and transformations
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // -- Validations and Error handling
        isAuthorized: function(data) {
            this.isAbsenceRequestAuthorized =
                data.hr_absence_request_status.status === 'Por Aprobar'
                    ? true
                    : false
            this.isEditable =
                data.hr_absence_request_status.status === 'Por Aprobar'
                    ? true
                    : false
        },
        // -- Other functions
        toggleOpen: function() {
            this.open = !this.open
            this.$refs.refAbsenceRequestFormDialog.editSwitch = false
        },
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                this.isAuthorized(this.absenceRequestObj)
                this.getInfoAbsenceRequest(this.absenceRequestObj)
            }
        },
        async responseConfirm(val) {
            //-
            if (val === 'Rechazar') {
                this.resetSnackbarState()
                let response = await rejectAbsenceRequest(
                    this.absenceRequestObj.id
                )
                //
                if (response.status == 'success') {
                    this.showSnackbar(
                        'success',
                        'Solicitud de ausencia ha sido rechazada',
                        ''
                    )
                    this.$emit('success')
                    this.toggleOpen()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
            if (val === 'Autorizar') {
                this.resetSnackbarState()
                let response = await authorizeAbsenceRequest(
                    this.absenceRequestObj.id
                )
                //
                if (response.status == 'success') {
                    this.showSnackbar(
                        'success',
                        'Solicitud de ausencia ha sido autorizada exitosamente',
                        ''
                    )
                    this.$emit('success')
                    this.toggleOpen()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount: async function() {
        this.setFieldOptionsData(0, await EmployeeService.fetchAll())
        this.setFieldOptionsData(1, await fetchAll())
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>